// extracted by mini-css-extract-plugin
export default {"card":"NotificationCard_card__z3F-E"};